// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header {\n  width: 100%;\n  height: 100px;\n}\n@media print {\n  .header {\n    display: none;\n  }\n}\n.header .header-content {\n  padding: 20px;\n  min-width: 40em;\n  height: 100%;\n}\n.header .header-content .logo {\n  height: 65%;\n}\n.header .header-content .status {\n  float: right;\n  font-size: 0.75em;\n}\n.header .header-content .help {\n  margin-left: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
